import { MessageBroker, PredefinedMessageTopics } from "@ng-mw/framework-core"
import { Store } from "redux"
import { RootState } from "@app/types"
import { extendedUserHasChanged, ChangeTrigger } from "@modules/user/store/actions/user"

interface ExtendedUserHasChangedMessage {
    topic: string
    data?: boolean
}

export default (store: Store<RootState, any>) => {
    MessageBroker.registerListener(
        PredefinedMessageTopics.EXTENDED_USER_HAS_CHANGED_LOCALLY,
        (message: ExtendedUserHasChangedMessage) =>
            store.dispatch(extendedUserHasChanged(ChangeTrigger.Local, !!message.data)),
    )
    MessageBroker.registerListener(
        PredefinedMessageTopics.EXTENDED_USER_HAS_CHANGED,
        (message: ExtendedUserHasChangedMessage) =>
            store.dispatch(extendedUserHasChanged(ChangeTrigger.Sync, !!message.data)),
    )
}
